(function () {
  'use strict';

  var root = document.getElementById('eros-reviews');
  if (!root) return;

  var handle = root.dataset.productHandle;
  var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
  if (!handle || !apiBase) return;

  var aggEl = root.querySelector('.eros-reviews__aggregate');
  var listEl = root.querySelector('.eros-reviews__list');
  var form = document.getElementById('eros-reviews-form');
  var starsEl = document.getElementById('eros-reviews-stars');
  var bodyEl = document.getElementById('eros-reviews-body');
  var loginGate = document.getElementById('eros-reviews-login-gate');
  var formMsg = document.getElementById('eros-reviews-form-msg');
  var locale = root.dataset.locale || 'ar';
  var cursor = null;
  var loading = false;
  var started = false;
  // SEO-2026-08-10: must match SEO_REVIEW_LIMIT in
  // cloudflare/reviews-worker/src/review_schema.ts, which is also what the
  // server-rendered preview (snippets/eros-reviews-ssr.liquid) and the Review
  // nodes in JSON-LD both carry. Google requires every review embedded in
  // structured data to be visible on the page; this list replaces the SSR
  // preview once it hydrates, so loading fewer than 10 here would recreate the
  // exact mismatch the worker change fixed — just on the rendered pass instead
  // of the raw one. Raise all three together or none.
  var initialPageSize = 10;
  var loadMorePageSize = 20;
  var totalReviewCount = 0;
  var selectedRating = 5;
  // ADR-174: identity comes from the phone+OTP session (window.ErosSession),
  // not a Shopify customer session — see eros-product-reviews.liquid's comment.
  var cachedDisplayName = null;
  var replyLabel = root.dataset.replyLabel || 'رد';
  var replySubmitLabel = root.dataset.replySubmitLabel || 'إرسال';
  // ADR-188: sourced from locales/ar.json (general.reviews.*) via the
  // section's data-* bridge — see sections/eros-product-reviews.liquid.
  var writeReplyRequiredMsg = root.dataset.writeReplyRequired || 'اكتب نص الرد.';
  var selectRatingRequiredMsg = root.dataset.selectRatingRequired || 'اختر تقييماً بالنجوم.';
  var photoInput = document.getElementById('eros-reviews-photo');
  var photoNameEl = document.getElementById('eros-reviews-photo-name');
  var pendingPhotoFile = null;
  var listSortBy = 'created_at';
  var listSortOrder = 'desc';
  var ratingOffset = 0;

  function photoHtml(url, alt) {
    if (!url) return '';
    return (
      '<button type="button" class="eros-reviews__photo-thumb-btn" data-action="zoom-photo" data-src="' +
      escapeHtml(url) +
      '"><img class="eros-reviews__photo eros-reviews__photo--thumb" src="' +
      escapeHtml(url) +
      '" alt="' +
      escapeHtml(alt || '') +
      '" loading="lazy" /></button>'
    );
  }

  function ensureLightbox() {
    if (document.getElementById('eros-reviews-lightbox')) return;
    var lb = document.createElement('div');
    lb.id = 'eros-reviews-lightbox';
    lb.className = 'eros-reviews__lightbox hidden';
    lb.innerHTML =
      '<button type="button" class="eros-reviews__lightbox-close" data-action="close-lightbox" aria-label="إغلاق">×</button>' +
      '<img class="eros-reviews__lightbox-img" src="" alt="" />';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (ev) {
      if (
        ev.target === lb ||
        ev.target.closest('[data-action="close-lightbox"]')
      ) {
        lb.classList.add('hidden');
        lb.querySelector('img').src = '';
      }
    });
  }

  function openPhotoLightbox(url) {
    ensureLightbox();
    var lb = document.getElementById('eros-reviews-lightbox');
    var img = lb.querySelector('img');
    img.src = url;
    lb.classList.remove('hidden');
  }

  function ensureSortBar() {
    if (root.querySelector('.eros-reviews__sort-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'eros-reviews__sort-bar';
    bar.innerHTML =
      '<label class="eros-reviews__sort-label">ترتيب' +
      '<select id="eros-reviews-sort-by" class="eros-reviews__sort-select">' +
      '<option value="created_at|desc">الأحدث</option>' +
      '<option value="created_at|asc">الأقدم</option>' +
      '<option value="rating|desc">الأعلى تقييماً</option>' +
      '<option value="rating|asc">الأقل تقييماً</option>' +
      '</select></label>';
    var list = root.querySelector('.eros-reviews__list');
    if (list) list.before(bar);
    bar.querySelector('select').addEventListener('change', function (ev) {
      var parts = String(ev.target.value || 'created_at|desc').split('|');
      listSortBy = parts[0] || 'created_at';
      listSortOrder = parts[1] || 'desc';
      cursor = null;
      ratingOffset = 0;
      loadReviews(false);
    });
  }

  function stars(n) {
    var max = 5;
    var out = '';
    for (var i = 0; i < max; i++) {
      out += i < n ? '★' : '☆';
    }
    return '<span class="eros-reviews__stars" aria-hidden="true">' + out + '</span>';
  }

  function buildStarInput() {
    if (!starsEl) return;
    starsEl.innerHTML = '';
    for (var i = 1; i <= 5; i++) {
      (function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'eros-reviews__star-btn' + (value <= selectedRating ? ' is-active' : '');
        btn.setAttribute('aria-label', value + '/5');
        btn.setAttribute('aria-pressed', value <= selectedRating ? 'true' : 'false');
        btn.textContent = '★';
        btn.addEventListener('click', function () {
          selectedRating = value;
          buildStarInput();
        });
        starsEl.appendChild(btn);
      })(i);
    }
  }

  function setFormMsg(text, isError) {
    if (!formMsg) return;
    formMsg.textContent = text || '';
    formMsg.classList.toggle('is-error', !!isError);
  }

  function showLoginGate() {
    if (loginGate) loginGate.hidden = false;
    setFormMsg('', false);
  }

  function hideLoginGate() {
    if (loginGate) loginGate.hidden = true;
  }

  /**
   * The server refused a session this page still believes in (expired or
   * revoked cookie). Drop the stale local session first, so «تسجيل الدخول»
   * opens the sign-in sheet instead of closing it at once (owner 2026-10-03:
   * the sheet never appeared).
   */
  function sessionRejected() {
    // ADR-306: commerce decides (renew first); the gate opens only when the session truly ended.
    var check = window.ErosCommerce && window.ErosCommerce.sessionEnded
      ? window.ErosCommerce.sessionEnded('invalid_token')
      : Promise.resolve(!isSignedIn());
    check.then(function (ended) {
      if (ended || !isSignedIn()) showLoginGate();
    });
  }

  /** After signing in: back to the composer with the text kept, as the app does. */
  function returnToComposer() {
    var target = bodyEl || form;
    if (!target) return;
    if (typeof target.scrollIntoView === 'function') target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (_) {
        target.focus();
      }
    }
  }

  function currentSession() {
    return window.ErosSession ? window.ErosSession.get() : null;
  }

  function isSignedIn() {
    var s = currentSession();
    return !!(s && s.customerGid);
  }

  function resolveDisplayName() {
    if (cachedDisplayName) return Promise.resolve(cachedDisplayName);
    if (!window.ErosCommerce) return Promise.resolve('');
    return window.ErosCommerce
      .getProfile()
      .then(function (res) {
        cachedDisplayName = (res.profile && res.profile.firstName) || '';
        return cachedDisplayName;
      })
      .catch(function () {
        return '';
      });
  }

  // Opens the same OTP sheet used by checkout (eros-checkout.js's
  // openAuthGate) — reuses window.ErosUI/window.ErosAccountAuth rather than
  // navigating to /account/login, which platform-redirects to Shopify's own
  // hosted login, entirely outside this identity system.
  function openReviewsLoginSheet(onSignedIn) {
    // Already signed in (e.g. in another tab): nothing to ask — just go on.
    if (isSignedIn()) {
      hideLoginGate();
      if (onSignedIn) onSignedIn();
      return;
    }
    var promptEl = loginGate && loginGate.querySelector('.eros-reviews__login-text');
    var panel = window.ErosUI.el('div', '', { 'data-eros-auth-panel': '' });
    var sheet = window.ErosUI.openSheet({
      title: promptEl ? promptEl.textContent : '',
      content: panel,
    });
    // eros-account-auth.js loads lazily (eros-lazy.js, idle ≤ 2 s on a product
    // page); a tap before that would leave the sheet empty — mount when ready.
    (function mountWhenReady(triesLeft) {
      if (window.ErosAccountAuth) {
        window.ErosAccountAuth.mountAll();
      } else if (triesLeft > 0) {
        setTimeout(function () {
          mountWhenReady(triesLeft - 1);
        }, 150);
      }
    })(60);

    var unsubscribe = window.ErosSession.onChange(function (session) {
      if (session && session.customerGid) {
        sheet.close();
        unsubscribe();
        hideLoginGate();
        cachedDisplayName = null;
        if (onSignedIn) onSignedIn();
      }
    });
  }

  function initials(name) {
    var parts = String(name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    return String(name || '?')
      .trim()
      .slice(0, 2)
      .toUpperCase();
  }

  /**
   * Same fallback as the app (ReviewAuthorAvatarAsset): no photo → the bundled
   * male avatar for authorGender 'male', the female one otherwise (the PO
   * default for null/unknown). A photo that fails to load falls back too.
   */
  function fallbackAvatarUrl(gender) {
    return gender === 'male' ? root.dataset.avatarMale : root.dataset.avatarFemale;
  }

  function avatarHtml(name, avatarUrl, compact, gender) {
    var cls = 'eros-reviews__avatar eros-reviews__avatar--img' + (compact ? ' eros-reviews__avatar--compact' : '');
    var fallback = fallbackAvatarUrl(gender);
    var src = avatarUrl || fallback;
    if (!src) {
      return '<div class="eros-reviews__avatar' + (compact ? ' eros-reviews__avatar--compact' : '') + '" aria-hidden="true">' + escapeHtml(initials(name)) + '</div>';
    }
    var fallbackAttr = avatarUrl && fallback ? ' data-eros-avatar-fallback="' + escapeHtml(fallback) + '"' : '';
    return (
      '<img class="' + cls + '" src="' + escapeHtml(src) + '"' + fallbackAttr +
      ' alt="" loading="lazy" width="36" height="36" />'
    );
  }

  // A profile photo that fails to load (deleted file, offline CDN) shows the
  // gender fallback instead of a broken image. `error` does not bubble, so
  // listen in the capture phase once for the whole section.
  root.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG' || !img.dataset || !img.dataset.erosAvatarFallback) return;
      var next = img.dataset.erosAvatarFallback;
      delete img.dataset.erosAvatarFallback;
      img.src = next;
    },
    true
  );

  function commentHeaderHtml(name, createdAt, rating) {
    var ratingHtml =
      rating != null
        ? '<div class="eros-reviews__comment-rating">' + stars(rating) + '</div>'
        : '';
    return (
      '<div class="eros-reviews__comment-header">' +
      '<div class="eros-reviews__comment-meta-top">' +
      '<strong class="eros-reviews__author">' +
      escapeHtml(name) +
      '</strong>' +
      ratingHtml +
      '</div>' +
      '<time datetime="' +
      createdAt +
      '">' +
      fmtRelative(createdAt) +
      '</time></div>'
    );
  }

  function fmtRelative(ms) {
    var diff = Date.now() - ms;
    var sec = Math.floor(diff / 1000);
    if (sec < 60) return 'الآن';
    var min = Math.floor(sec / 60);
    if (min < 60) return min + ' د';
    var hr = Math.floor(min / 60);
    if (hr < 24) return hr + ' س';
    var day = Math.floor(hr / 24);
    if (day < 7) return day + ' ي';
    try {
      return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(new Date(ms));
    } catch (e) {
      return '';
    }
  }

  function reportBtnHtml(targetType, targetId) {
    return (
      '<button type="button" class="eros-reviews__meta-btn eros-reviews__report-btn" data-action="report" data-target-type="' +
      targetType +
      '" data-target-id="' +
      escapeHtml(targetId) +
      '">إبلاغ</button>'
    );
  }

  function replyFormHtml(reviewId, parentReplyId) {
    var parentAttr = parentReplyId
      ? ' data-parent-reply-id="' + escapeHtml(parentReplyId) + '"'
      : '';
    return (
      '<form class="eros-reviews__reply-form" data-action="reply-form" data-review-id="' +
      escapeHtml(reviewId) +
      '"' +
      parentAttr +
      ' hidden novalidate>' +
      '<div class="eros-reviews__identity-slot"></div>' +
      '<div class="eros-reviews__composer eros-reviews__composer--reply">' +
      '<textarea class="eros-reviews__textarea" rows="1" placeholder="' +
      escapeHtml(replyLabel) +
      '…" aria-label="' +
      escapeHtml(replyLabel) +
      '"></textarea>' +
      '<button type="submit" class="eros-reviews__composer-send">' +
      escapeHtml(replySubmitLabel) +
      '</button></div>' +
      '<p class="eros-reviews__reply-msg" aria-live="polite"></p></form>'
    );
  }

  function replyNodeHtml(reply, reviewId) {
    var nested = (reply.replies || [])
      .map(function (child) {
        return replyNodeHtml(child, reviewId);
      })
      .join('');
    var nestedBlock = nested ? '<div class="eros-reviews__replies">' + nested + '</div>' : '';
    // ADR-204: the store's official answer — badged, styled, always first (server order).
    var official = reply.isOfficial === true;
    return (
      '<div class="eros-reviews__reply' + (official ? ' eros-reviews__reply--official' : '') + '" data-reply-id="' +
      escapeHtml(reply.id) +
      '">' +
      avatarHtml(reply.authorDisplayName, reply.authorAvatarUrl, true, reply.authorGender) +
      '<div class="eros-reviews__comment-main">' +
      commentHeaderHtml(reply.authorDisplayName, reply.createdAt, null) +
      (official ? '<span class="eros-reviews__official-badge">✓ رد رسمي من فريق إيروس</span>' : '') +
      '<p class="eros-reviews__comment-body">' +
      escapeHtml(reply.body) +
      '</p>' +
      (reply.imageUrl ? photoHtml(reply.imageUrl, reply.authorDisplayName) : '') +
      '<div class="eros-reviews__comment-meta">' +
      '<button type="button" class="eros-reviews__meta-btn" data-action="toggle-reply">' +
      escapeHtml(replyLabel) +
      '</button>' +
      (official ? '' : reportBtnHtml('reply', reply.id)) +
      '</div>' +
      replyFormHtml(reviewId, reply.id) +
      nestedBlock +
      '</div></div>'
    );
  }

  function card(review) {
    var img = review.imageUrl ? photoHtml(review.imageUrl, review.authorDisplayName) : '';
    var bodyText = String(review.body || '').trim();
    var bodyHtml = bodyText.length
      ? escapeHtml(bodyText)
      : '';
    var replies = review.replies || [];
    var repliesHtml = '';
    if (replies.length) {
      repliesHtml =
        '<div class="eros-reviews__replies">' +
        replies.map(function (r) {
          return replyNodeHtml(r, review.id);
        }).join('') +
        '</div>';
    }
    return (
      '<article class="eros-reviews__thread" data-review-id="' +
      escapeHtml(review.id) +
      '">' +
      '<div class="eros-reviews__comment">' +
      avatarHtml(review.authorDisplayName, review.authorAvatarUrl, false, review.authorGender) +
      '<div class="eros-reviews__comment-main">' +
      commentHeaderHtml(review.authorDisplayName, review.createdAt, review.rating) +
      (bodyHtml ? '<p class="eros-reviews__comment-body">' + bodyHtml + '</p>' : '') +
      img +
      '<div class="eros-reviews__comment-meta">' +
      '<button type="button" class="eros-reviews__meta-btn" data-action="toggle-reply">' +
      escapeHtml(replyLabel) +
      '</button>' +
      reportBtnHtml('review', review.id) +
      '</div>' +
      repliesHtml +
      replyFormHtml(review.id, '') +
      '</div></div></article>'
    );
  }

  function escapeHtml(s) {
    // Escapes all 5 HTML-significant chars including the single quote (&#39;).
    // Every current call site places the result inside a double-quoted
    // attribute or element text, where a bare ' is harmless — but escaping it
    // too keeps this safe if a value is ever moved into a single-quoted
    // attribute by a future edit (matches the canonical version in
    // eros-hybrid-search.js).
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function uploadReplyPhoto(reviewId, replyId, file) {
    var fd = new FormData();
    fd.append('file', file);
    var headers = { Accept: 'application/json' };
    return fetch(
      apiBase + '/api/v1/reviews/' + encodeURIComponent(reviewId) + '/replies/' + encodeURIComponent(replyId) + '/image',
      {
        method: 'POST',
        credentials: 'include',
        headers: headers,
        body: fd,
      },
    ).then(function (res) {
      if (!res.ok) {
        // ADR-204: keep the server code (image_rejected / image_check_unavailable).
        return res.json().catch(function () { return {}; }).then(function (d) {
          throw new Error((d && d.error) || 'photo_upload_failed');
        });
      }
      return res.json();
    });
  }

  function uploadReviewPhoto(reviewId, file) {
    var fd = new FormData();
    fd.append('file', file);
    var headers = { Accept: 'application/json' };
    return fetch(apiBase + '/api/v1/reviews/' + encodeURIComponent(reviewId) + '/image', {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: fd,
    }).then(function (res) {
      if (!res.ok) {
        // ADR-204: keep the server code (image_rejected / image_check_unavailable).
        return res.json().catch(function () { return {}; }).then(function (d) {
          throw new Error((d && d.error) || 'photo_upload_failed');
        });
      }
      return res.json();
    });
  }

  function clearPendingPhoto() {
    pendingPhotoFile = null;
    if (photoInput) photoInput.value = '';
    if (photoNameEl) {
      photoNameEl.textContent = '';
      photoNameEl.hidden = true;
    }
    var cameraBtn = document.getElementById('eros-reviews-camera-btn');
    if (cameraBtn) cameraBtn.classList.remove('is-active');
  }

  function setCameraActive(active) {
    var cameraBtn = document.getElementById('eros-reviews-camera-btn');
    if (cameraBtn) cameraBtn.classList.toggle('is-active', !!active);
  }

  function fetchJson(path, options) {
    return fetch(apiBase + path, options || { credentials: 'omit' }).then(function (res) {
      if (!res.ok) {
        return res
          .json()
          .catch(function () {
            throw new Error('http_' + res.status);
          })
          .then(function (data) {
            var err = new Error(data.error || 'http_' + res.status);
            err.status = res.status;
            err.payload = data;
            throw err;
          });
      }
      return res.json();
    });
  }

  function renderAggregate(agg) {
    if (!aggEl) return;
    totalReviewCount = agg && agg.reviewCount ? agg.reviewCount : 0;
    if (!agg || !agg.reviewCount) {
      aggEl.textContent = '';
      return;
    }
    aggEl.innerHTML =
      stars(Math.round(agg.averageRating)) +
      ' <strong>' +
      agg.averageRating.toFixed(1) +
      '</strong> / 5 (' +
      agg.reviewCount +
      ')';
  }

  function loadReviews(append) {
    if (loading || !listEl) return;
    loading = true;
    var pageLimit = append ? loadMorePageSize : initialPageSize;
    var q = '?limit=' + pageLimit + '&sortBy=' + encodeURIComponent(listSortBy) + '&sortOrder=' + encodeURIComponent(listSortOrder);
    if (listSortBy === 'rating') {
      if (append && ratingOffset) q += '&offset=' + encodeURIComponent(String(ratingOffset));
    } else if (cursor) {
      q += '&cursor=' + encodeURIComponent(String(cursor));
    }
    fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/reviews' + q)
      .then(function (data) {
        var items = data.items || [];
        if (!append) listEl.innerHTML = '';
        if (!items.length && !append) {
          listEl.innerHTML = '<p class="eros-reviews__empty">لا توجد تقييمات بعد.</p>';
        } else {
          listEl.insertAdjacentHTML('beforeend', items.map(card).join(''));
        }
        cursor = data.nextCursor || null;
        if (listSortBy === 'rating' && data.offset != null) ratingOffset = data.offset;
        listEl.setAttribute('aria-busy', 'false');
        maybeAddLoadMore();
      })
      .catch(function () {
        listEl.innerHTML = '<p class="eros-reviews__empty">تعذّر تحميل التقييمات.</p>';
        listEl.setAttribute('aria-busy', 'false');
      })
      .finally(function () {
        loading = false;
      });
  }

  function maybeAddLoadMore() {
    var btn = root.querySelector('.eros-reviews__load-more');
    if (btn) btn.remove();
    var displayed = listEl.querySelectorAll('.eros-reviews__thread').length;
    if (totalReviewCount <= initialPageSize || displayed >= totalReviewCount) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eros-reviews__load-more';
    btn.textContent = 'عرض المزيد من التعليقات';
    btn.addEventListener('click', function () {
      loadReviews(true);
    });
    listEl.after(btn);
  }

  function submitReply(reviewId, replyForm) {
    var textarea = replyForm.querySelector('textarea');
    var msgEl = replyForm.querySelector('.eros-reviews__reply-msg');
    var submitBtn = replyForm.querySelector('button[type="submit"]');
    var text = (textarea && textarea.value ? textarea.value : '').trim();

    function setReplyMsg(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.classList.toggle('is-error', !!isError);
    }

    setReplyMsg('', false);
    if (!text.length) {
      setReplyMsg(writeReplyRequiredMsg, true);
      return;
    }

    var session = currentSession();
    if (!session || !session.customerGid) {
      showLoginGate();
      return;
    }

    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (submitBtn) submitBtn.disabled = true;

    var parentReplyId = replyForm.getAttribute('data-parent-reply-id');

    resolveDisplayName()
      .then(function (name) {
        var payload = {
          body: text,
          locale: locale,
          customerGid: session.customerGid,
          authorDisplayName: name,
        };
        if (parentReplyId) payload.parentReplyId = parentReplyId;

        return fetchJson(
          '/api/v1/theme/products/' +
            encodeURIComponent(handle) +
            '/reviews/' +
            encodeURIComponent(reviewId) +
            '/replies',
          {
            method: 'POST',
            credentials: 'include',
            headers: headers,
            body: JSON.stringify(payload),
          },
        );
      })
      .then(function (data) {
        var replyId = data.reply && data.reply.id;
        if (textarea) textarea.value = '';
        replyForm.hidden = true;
        setReplyMsg('', false);
        if (data.status === 'approved') {
          setFormMsg('', false);
          cursor = null;
          ratingOffset = 0;
          loadReviews(false);
          return fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/aggregate');
        }
        setFormMsg('تم إرسال ردك — سيُراجع قبل النشر.', false);
      })
      .catch(function (err) {
        if (err.status === 401 || (err.payload && err.payload.error === 'login_required')) {
          sessionRejected();
          return;
        }
        if (err.payload && err.payload.error === 'rate_limited') {
          setReplyMsg('محاولات كثيرة — حاول لاحقاً.', true);
          return;
        }
        setReplyMsg('تعذّر إرسال الرد.', true);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  /**
   * ADR-204 «سيُنشر باسم»: above the composers, the customer's own avatar
   * and name exactly as others will see them.
   */
  var myProfile = null;
  function loadMyProfile() {
    if (myProfile) return Promise.resolve(myProfile);
    if (!isSignedIn() || !window.ErosCommerce) return Promise.resolve(null);
    return window.ErosCommerce.getProfile()
      .then(function (res) {
        var p = (res && res.profile) || {};
        myProfile = {
          name: String(p.lastName || p.firstName || '').trim(),
          avatarUrl: p.profilePhotoUrl || '',
          gender: p.identityGender === 'ذكر' ? 'male' : 'female',
        };
        return myProfile;
      })
      .catch(function () {
        return null;
      });
  }

  function identityHtml(p) {
    return (
      '<div class="eros-reviews__identity">' +
      avatarHtml(p.name, p.avatarUrl, true, p.gender) +
      '<span>سيُنشر باسم: <strong>' + escapeHtml(p.name || '—') + '</strong></span></div>'
    );
  }

  function fillIdentity(slot) {
    if (!slot) return;
    loadMyProfile().then(function (p) {
      slot.innerHTML = p && p.name ? identityHtml(p) : '';
    });
  }

  var REPORT_REASONS = [
    ['inappropriate_image', 'صورة غير لائقة'],
    ['offensive_text', 'كلام مسيء'],
    ['spam', 'إعلان أو رسائل مزعجة'],
    ['other', 'سبب آخر'],
  ];

  function openReportSheet(targetType, targetId) {
    if (!isSignedIn()) {
      openReviewsLoginSheet(function () {
        openReportSheet(targetType, targetId);
      });
      return;
    }
    if (!window.ErosUI) return;
    var body = window.ErosUI.el('div', 'eros-reviews__report-sheet');
    var sheet = window.ErosUI.openSheet({ title: 'لماذا تبلّغ عن هذا؟', content: body });
    REPORT_REASONS.forEach(function (r) {
      var b = window.ErosUI.el('button', 'button button--secondary eros-reviews__report-reason', { type: 'button' });
      b.textContent = r[1];
      b.addEventListener('click', function () {
        body.querySelectorAll('button').forEach(function (x) {
          x.disabled = true;
        });
        fetchJson('/api/v1/reports', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ targetType: targetType, targetId: targetId, reason: r[0] }),
        })
          .then(function () {
            sheet.close();
            window.ErosUI.toast('شكراً، وصلنا بلاغك وسنراجعه', 'info');
          })
          .catch(function (err) {
            if (err.status === 401) {
              sheet.close();
              sessionRejected();
              return;
            }
            body.querySelectorAll('button').forEach(function (x) {
              x.disabled = false;
            });
            window.ErosUI.toast(
              err.payload && err.payload.error === 'rate_limited' ? 'بلاغات كثيرة اليوم — حاول غداً' : 'تعذّر إرسال البلاغ، حاول مرة أخرى',
              'error',
            );
          });
      });
      body.appendChild(b);
    });
  }

  function onListClick(ev) {
    var zoom = ev.target.closest('[data-action="zoom-photo"]');
    if (zoom) {
      openPhotoLightbox(zoom.getAttribute('data-src'));
      return;
    }
    var reportBtn = ev.target.closest('[data-action="report"]');
    if (reportBtn) {
      openReportSheet(reportBtn.getAttribute('data-target-type'), reportBtn.getAttribute('data-target-id'));
      return;
    }
    var toggle = ev.target.closest('[data-action="toggle-reply"]');
    if (!toggle) return;

    if (!isSignedIn()) {
      openReviewsLoginSheet(function () {
        toggle.click();
      });
      return;
    }

    var host = toggle.closest('.eros-reviews__comment-main');
    if (!host) return;
    var replyForm = host.querySelector(':scope > .eros-reviews__reply-form[data-action="reply-form"]');
    if (!replyForm) return;

    var thread = toggle.closest('.eros-reviews__thread');
    if (thread) {
      thread.querySelectorAll('.eros-reviews__reply-form').forEach(function (f) {
        if (f !== replyForm) f.hidden = true;
      });
    }

    replyForm.hidden = !replyForm.hidden;
    if (!replyForm.hidden) {
      fillIdentity(replyForm.querySelector('.eros-reviews__identity-slot'));
      var ta = replyForm.querySelector('textarea');
      if (ta) ta.focus();
    }
  }

  function onListSubmit(ev) {
    var replyForm = ev.target.closest('[data-action="reply-form"]');
    if (!replyForm) return;
    ev.preventDefault();
    var reviewId = replyForm.getAttribute('data-review-id');
    if (!reviewId) return;
    submitReply(reviewId, replyForm);
  }

  function submitReview(ev) {
    ev.preventDefault();
    hideLoginGate();
    setFormMsg('', false);

    var text = (bodyEl && bodyEl.value ? bodyEl.value : '').trim();
    if (selectedRating < 1) {
      setFormMsg(selectRatingRequiredMsg, true);
      return;
    }

    var session = currentSession();
    if (!session || !session.customerGid) {
      showLoginGate();
      return;
    }

    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

    var submitBtn = form && form.querySelector('.eros-reviews__composer-send');
    if (submitBtn) submitBtn.disabled = true;

    resolveDisplayName()
      .then(function (name) {
        return fetchJson('/api/v1/theme/products/' + encodeURIComponent(handle) + '/reviews', {
          method: 'POST',
          credentials: 'include',
          headers: headers,
          body: JSON.stringify({
            body: text,
            rating: selectedRating,
            locale: locale,
            customerGid: session.customerGid,
            authorDisplayName: name,
          }),
        });
      })
      .then(function (data) {
        var reviewId = data.review && data.review.id;
        var chain = Promise.resolve();
        if (pendingPhotoFile && reviewId) {
          chain = uploadReviewPhoto(reviewId, pendingPhotoFile).then(
            function () {
              return { photoFailed: false };
            },
            function (err) {
              return { photoFailed: true, code: err && err.message };
            },
          );
        }
        return chain.then(function (photoResult) {
          if (bodyEl) bodyEl.value = '';
          clearPendingPhoto();
          selectedRating = 5;
          buildStarInput();
          cursor = null;
          ratingOffset = 0;
          if (photoResult && photoResult.photoFailed && photoResult.code === 'image_rejected') {
            setFormMsg('تم إرسال التقييم — لم تُنشر الصورة لأنها لا تناسب النشر.', true);
          } else if (data.status === 'approved') {
            if (photoResult && photoResult.photoFailed) {
              setFormMsg('تم نشر التقييم — تعذّر رفع الصورة.', false);
            } else {
              setFormMsg('', false);
            }
          } else if (photoResult && photoResult.photoFailed) {
            setFormMsg('تم إرسال التقييم — تعذّر رفع الصورة.', false);
          } else {
            setFormMsg('تم إرسال تقييمك — سيُراجع قبل النشر.', false);
          }
          loadReviews(false);
          return fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/aggregate');
        });
      })
      .then(function (data) {
        if (data && data.aggregate) renderAggregate(data.aggregate);
      })
      .catch(function (err) {
        if (err.status === 401 || (err.payload && err.payload.error === 'login_required')) {
          sessionRejected();
          return;
        }
        if (err.payload && err.payload.error === 'rate_limited') {
          setFormMsg('محاولات كثيرة — حاول لاحقاً.', true);
          return;
        }
        setFormMsg('تعذّر إرسال التقييم. حاول مرة أخرى.', true);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function bootList() {
    if (started) return;
    started = true;
    var ssrEl = document.getElementById('eros-reviews-ssr');
    if (ssrEl) ssrEl.hidden = true;
    fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/aggregate')
      .then(function (data) {
        renderAggregate(data.aggregate);
        loadReviews(false);
      })
      .catch(function () {
        loadReviews(false);
      });
  }

  function initForm() {
    // ADR-204: «سيُنشر باسم» above the main composer, refreshed on sign-in/out.
    var identitySlot = document.getElementById('eros-reviews-identity');
    fillIdentity(identitySlot);
    if (window.ErosSession && typeof window.ErosSession.onChange === 'function') {
      window.ErosSession.onChange(function () {
        myProfile = null;
        fillIdentity(identitySlot);
      });
    }

    ensureLightbox();
    ensureSortBar();
    buildStarInput();
    if (form) form.addEventListener('submit', submitReview);
    if (listEl) {
      listEl.addEventListener('click', onListClick);
      listEl.addEventListener('submit', onListSubmit);
    }
    var loginBtn = document.getElementById('eros-reviews-login-btn');
    if (loginBtn) {
      loginBtn.addEventListener('click', function () {
        openReviewsLoginSheet(returnToComposer);
      });
    }

    var cameraBtn = document.getElementById('eros-reviews-camera-btn');
    if (cameraBtn && photoInput) {
      cameraBtn.addEventListener('click', function () {
        photoInput.click();
      });
    }

    if (photoInput) {
      photoInput.addEventListener('change', function () {
        pendingPhotoFile = photoInput.files && photoInput.files[0] ? photoInput.files[0] : null;
        setCameraActive(!!pendingPhotoFile);
        if (photoNameEl) {
          if (pendingPhotoFile) {
            photoNameEl.textContent = pendingPhotoFile.name;
            photoNameEl.hidden = false;
          } else {
            photoNameEl.textContent = '';
            photoNameEl.hidden = true;
          }
        }
      });
    }

    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('review') === '1') {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (bodyEl) bodyEl.focus();
      }
    } catch (e) {}
  }

  initForm();

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.disconnect();
            bootList();
          }
        });
      },
      { rootMargin: '200px' },
    );
    io.observe(root);
  } else {
    bootList();
  }
})();
